export const ERROR_MESSAGE = 'Failed to fetch project listings from perseus';
